import { Button } from '../../cdl/Button/Button';
import { useDrawer } from '../../cdl/Drawer/useDrawer.hook';
import { translate } from '../../common/helpers/translate.helper';
import { useRole } from '../../common/hooks/useRole';
import { IconPlus } from '../../common/icons/cdl/Plus';
import { CreateAgentForm } from '../CreateAgentForm/CreateAgentForm';

export const CreateAgentButton = () => {
    const { push, pop } = useDrawer();
    const role = useRole();

    const companyId = role.isOneCompanyUser() ? role.getCompanies().map((company) => company.id)[0] : undefined;

    const openCreateAgentModal = () => {
        const drawerId = push({
            header: { title: translate('agents.createAgent') },
            content: (
                <CreateAgentForm
                    data={{
                        name: '',
                        portIds: [],
                        customerId: companyId,
                    }}
                    onSuccess={() => pop(drawerId)}
                    showCompanySelect={role.isSuperAdmin() || !role.isOneCompanyUser()}
                />
            ),
        });
    };

    return (
        <Button emphasis="high" LeadingIcon={IconPlus} onClick={openCreateAgentModal}>
            {translate('agents.createAgent')}
        </Button>
    );
};
